import Helpers from '../js/helpers';

export default new class ShowMore {
  /**
     * this.showMoreInit - Init ShowMore
     * this.showMoreButton - Button, which open hidden elements
     * this.showMoreTooltip - Parent element for hidden content
     * this.initialized - this classname added when ShowMore was initialized
     */
  constructor() {
    this.isBinded = false;

    this.showMoreInit = 'js-show-more-init';
    this.showMoreButton = 'js-show-more-button';
    this.showMoreTooltip = 'js-show-more-tooltip';
    this.initialized = 'js-show-more-initialized';
    this.showMoreElement = 'js-show-more-element';

    this.indendBeforeBorder = 20;

    if ($('.js-show-more-init').length) {
      this.initComponents();
      this.initBindings();
    }
  }

  initComponents(isNeedToReRender) {
    const $parentElements = isNeedToReRender ? $(`.${this.showMoreInit}`) : $(`.${this.showMoreInit}`).not(`.${this.initialized}`);
    $parentElements.each((index, parentElement) => {
      const $parentElement = $(parentElement);
      const showMoreButtonWidth = $parentElements.find(`.${this.showMoreButton}`).outerWidth(true);
      const parentElementWidth = $parentElement.css('width');

      if (parentElementWidth !== '0px') {
        const parentWidth = $parentElement.outerWidth() - showMoreButtonWidth;
        const $childrenItems = $parentElement.find(`.${this.showMoreElement}`);
        let childrenWidth = 0;
        let dirty = false;

        $childrenItems.each((_, item) => {
          childrenWidth += $(item).outerWidth(true);

          if (parentWidth < childrenWidth) {
            const $item = $(item);
            $item.addClass('_hidden').hide();
            $item.next(`.${this.showMoreElement}`).not(`.${this.showMoreButton}`).hide();
            dirty = true;
          }
        });

        $parentElement.addClass(this.initialized);

        if (dirty) {
          $parentElement.find(`.${this.showMoreButton}`).show();
        }
      }

      /* Because of the bug
        - appearing of an empty tooltip block for a moment before links are added to the tooltip -
        one needs to hide tooltip first by adding class '_no-hover'.
        This class is removed after links are added. See line 88 */
      if (Helpers.isMobile()) {
        $parentElements.find(`.${this.showMoreButton}`).addClass('_no-hover');
      }
    });
  }

  initBindings() {
    if (this.isBinded) {
      return;
    }

    if (Helpers.isMobile()) {
      $(document).on('click', `.${this.showMoreButton}`, (e) => {
        $('.show-more-item').click((event) => {
          event.preventDefault();
        });

        e.stopPropagation();

        const $btns = $(e.target);
        this.showTooltip($btns);

        $btns.removeClass('_no-hover');
      });

      $(window).on('orientationchange', () => {
        const isNeedToReRender = true;

        setTimeout(() => {
          this.initComponents(isNeedToReRender);
        }, 100);
      });
    } else {
      $(document).on('mouseover', `.${this.showMoreButton}`, (e) => {
        e.stopPropagation();
        this.showTooltip($(e.target));
      });
    }

    this.isBinded = true;
  }

  showTooltip($target) {
    const $showMore = $target.closest(`.${this.showMoreButton}`);
    const $parent = $showMore.closest(`.${this.showMoreInit}`);
    const $tooltip = $showMore.find(`.${this.showMoreTooltip}`);
    const tooltipPosition = $tooltip.offset().left + $tooltip.outerWidth();
    const $body = $('body');

    if (Helpers.isMobile()) {
      const windowWidth = $(window).width();
      const containerPadding = 20;
      const topOffset = 20;
      const tooltipBtnLeftOffset = $showMore[0].getBoundingClientRect().left;

      $tooltip.css('width', windowWidth - containerPadding * 2);
      $tooltip.css('left', containerPadding - tooltipBtnLeftOffset);
      $tooltip.css('top', topOffset);
    } else if (tooltipPosition > $body.outerWidth()) {
      $tooltip.css('left', parseInt($tooltip.css('left'), 10) + $body.outerWidth() - tooltipPosition - this.indendBeforeBorder);
    }

    if (!$tooltip.data('dirty')) {
      this.renderHiddenContent($parent.find('._hidden'), $tooltip);
      $tooltip.data('dirty', 'true');
    }
  }

  renderHiddenContent($items, appendToSelector) {
    $items.each((_, item) => {
      $(`<div class='show-more-item'>#${$(item).find('div').text()}</div>`).appendTo(appendToSelector);
    });
  }
}();
